export default {
  'exception-403.exception.back': 'Back to home',
  'exception-403.description.403': "Sorry, you don't have access to this page",
};
